import {gql} from "@apollo/client/core";
import {ShopSessionDashboardFragment} from "../fragments/shop-session-dashboard-fragment";
import {ShopSessionDashboardShareFragment} from "../fragments/shop-session-dashboard-share-fragment";

export const SaveShopSessionEvent = gql`
    mutation SaveShopSessionEvent($shopSessionEventInput: ShopSessionEventInput)
    {
        saveShopSessionEvent(shopSessionEventInput: $shopSessionEventInput)
    }
`;

export const SaveFirstShopSessionEvent = gql`
    mutation SaveFirstShopSessionEvent($referer: String)
    {
        saveFirstShopSessionEvent(referer: $referer)
    }
`;

export const GetShopSessionDashboard = gql`
    query GetShopSessionDashboard
    {
        getShopSessionDashboard {
            ...ShopSessionDashboardFragment
        }
    }
     ${ShopSessionDashboardFragment}
`;

export const GetShopSessionDashboardShare = gql`
    query GetShopSessionDashboardShare($dashboardTotalsFilter: DashboardTotalsFilter)
    {
        getShopSessionDashboardShare(dashboardTotalsFilter: $dashboardTotalsFilter) {
            ...ShopSessionDashboardShareFragment
        }
    }
     ${ShopSessionDashboardShareFragment}
`;

export const GetDashboardSharePrep = gql`
    query GetDashboardSharePrep($secondsBack: Long)
    {
        getDashboardSharePrep(secondsBack: $secondsBack)
        {
            shopperSources
            shareTypes
            shareFroms
        }
    }
`;
